'use client';

import { useTransition } from 'react';

import { Bell } from 'lucide-react';

import { useToggleMessageNotification } from '../../hooks/useToggleMessageNotification';

interface Props {
  channelId: string;
  messageId: string;
}

/**
 * Filled bell badge shown in a message header when the current user has
 * subscribed to that message's reply-thread notifications (mirrors PopshopRN's
 * header bell). Only rendered by the bubble when subscribed, so the click always
 * unsubscribes.
 */
export function MessageSubscriptionIndicator({ channelId, messageId }: Props) {
  const toggleNotification = useToggleMessageNotification({
    channelId,
    messageId,
  });
  const [pending, startTransition] = useTransition();

  const onUnsubscribe = () => {
    if (pending) return;
    startTransition(async () => {
      try {
        await toggleNotification();
      } catch (error) {
        console.error('unsubscribe channel message notification failed', error);
      }
    });
  };

  return (
    <button
      type="button"
      onClick={onUnsubscribe}
      disabled={pending}
      aria-label="Turn off notifications for this message"
      className="text-brand-text hover:text-brand-hover disabled:opacity-60"
    >
      <Bell className="h-4 w-4 fill-current" aria-hidden />
    </button>
  );
}
